import * as Sf from '../../utils/services/salesforce';
import * as Query from '../../queries';

export const getUserProfile = salesforceUser => {
  if (salesforceUser && salesforceUser.id) {
    return new Promise((resolve, reject) => {
      const profile = { name: undefined, id: undefined };
      Sf.runQuery(Query.getUserProfile(salesforceUser.id))
        .then(res => {
          if (res.totalSize > 0) {
            const [rawProfile] = res.records;

            profile.name = rawProfile.Profile.Name;
            profile.id = rawProfile.ProfileId;
            profile.email = rawProfile.Email;
            profile.fullName = rawProfile.Name;
          }
          resolve(profile);
        })
        .catch(err => {
          reject(err);
        });
    });
  } else {
    return undefined;
  }
};

export const getUserMember = salesforceUser => {
  if (salesforceUser && salesforceUser.id) {
    return new Promise((resolve, reject) => {
      Sf.runQuery(Query.getUserMember(salesforceUser.id))
        .then(res => {
          if (res.totalSize === 0) {
            resolve(undefined);
          } else {
            resolve(res.records[0]);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  } else {
    return undefined;
  }
};

export const getAdmins = () => {
  const query = Query.getCTCByName('Controle de Acesso - Administradores');
  return new Promise((resolve, reject) => {
    Sf.runQuery(query)
      .then(res => {
        try {
          const allAdminUsers = JSON.parse(res.records[0].Structure__c).users;
          resolve(allAdminUsers);
        } catch (err) {
          resolve([]);
        }
      })
      .catch(err => reject(err));
  });
};

export const getPlanningMembers = () => {
  const query = Query.getCTCByName('Controle de Acesso - Planejamento RC');
  return new Promise((resolve, reject) => {
    Sf.runQuery(query)
      .then(res => {
        try {
          const allUsers = JSON.parse(res.records[0].Structure__c).users;
          resolve(allUsers);
        } catch (err) {
          resolve([]);
        }
      })
      .catch(err => reject(err));
  });
};
